<template>
  <h1>Room Features</h1>
</template>

<script setup lang="ts"></script>

<style lang="postcss" scoped></style>
